module.exports = __webpack_public_path__ + "static/img/1.2b1ce86.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/3/zh/1.png
// module id = sNZo
// module chunks = 0